import { IAPICategoriesModel } from "../interfaces/CategoriesInterfaces";

 
export class CategoriesModel {
    id: string;
    name: string;
    usedInItems: number;

    constructor(data?: Partial<CategoriesModel>) {
        this.id = data?.id || '';
        this.name = data?.name || '';
        this.usedInItems = data?.usedInItems || 0;
    }

    createAPIModel(): IAPICategoriesModel {
        return {
            id: this.id,
            name: this.name,
            used: this.usedInItems,
        };
    }

    static deserialize(data: IAPICategoriesModel): CategoriesModel {
        const mappedData = {
            id: data.id,
            name: data.name,
            usedInItems: data.used,
        };
        return new CategoriesModel(mappedData);
    }
}
